import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

type Props = {
  imEvent: ImEventDto;
};

export const OrganizerRow: React.FC<Props> = ({
  imEvent: { organizerName }
}) => {
  return (
    <>
      {organizerName && (
        <TableRow>
          <TableCell>イベント主催者</TableCell>
          <TableCell>{organizerName}</TableCell>
        </TableRow>
      )}
    </>
  );
};
